import { Auth } from "./types";
const timeoutMinutes = 10;
const timeoutInMilliseconds = timeoutMinutes * 60 * 1000;
const getSessionTimeout = () => {
    const sessionTimeout = window.localStorage.getItem(Auth.SESSION_TIMEOUT);
    return sessionTimeout ? JSON.parse(sessionTimeout) : null;
};
const setSessionTimeout = (sessionTimeout) => {
    window.localStorage.setItem(Auth.SESSION_TIMEOUT, JSON.stringify(sessionTimeout));
};
const startSessionTimeout = () => {
    const timeoutId = setTimeout(() => {
        expireSessionTimeout();
    }, timeoutInMilliseconds);
    const sessionTimeout = {
        id: timeoutId,
        started: new Date().getTime().toString(),
    };
    // Listen for session renewal events
    window.addEventListener(Auth.RENEW_SESSION, renewSessionTimeout);
    setSessionTimeout(sessionTimeout);
};
const renewSessionTimeout = () => {
    const lastSessionTimeout = getSessionTimeout();
    if (lastSessionTimeout === null) {
        expireSessionTimeout();
        return;
    }
    const lastTouch = parseInt(lastSessionTimeout.started, 10);
    const now = new Date().getTime();
    if (lastTouch && now - lastTouch > timeoutInMilliseconds) {
        expireSessionTimeout();
        return;
    }
    // Kill old session
    clearTimeout(lastSessionTimeout.id);
    startSessionTimeout();
};
const expireSessionTimeout = () => {
    deleteCurrentSessionTimeout();
    const event = new Event(Auth.EXPIRED_SESSION);
    dispatchEvent(event);
};
const deleteCurrentSessionTimeout = () => {
    const lastSessionTimeout = getSessionTimeout();
    if (lastSessionTimeout !== null) {
        clearTimeout(lastSessionTimeout.id);
        window.localStorage.removeItem(Auth.SESSION_TIMEOUT);
    }
};
const onSessionTimeoutExpire = (callback) => {
    window.addEventListener(Auth.EXPIRED_SESSION, callback);
};
export { startSessionTimeout, renewSessionTimeout, onSessionTimeoutExpire, deleteCurrentSessionTimeout, };
